// extracted by mini-css-extract-plugin
var _1 = "SidebarItems-module__list--nc0Zo";
export { _1 as "list" }
